import { PopoverTriggerStrategy } from './PopoverTriggerStrategy';
import { getHostChildsFromEvent } from '../../common/utils/DomUtil';
export class PopoverTriggerClickStrategy extends PopoverTriggerStrategy {
    constructor() {
        super(...arguments);
        this.handleTriggerClick = () => {
            if (this.popover.isOpen) {
                this.popover.close();
            }
            else {
                this.popover.open();
                this.hasBeenTriggeredBy = 'click';
            }
        };
        this.handleGlobalClick = (e) => {
            const childs = getHostChildsFromEvent(e, this.popover);
            if (!childs.length) {
                this.popover.close();
            }
        };
    }
    init() {
        super.init();
        this.trigger.addEventListener('click', this.handleTriggerClick);
    }
    dispose() {
        this.trigger.removeEventListener('click', this.handleTriggerClick);
        this.unbindGlobalListener();
    }
    internalOnOpen() {
        document.addEventListener('click', this.handleGlobalClick);
    }
    internalOnClose() {
        this.unbindGlobalListener();
    }
    unbindGlobalListener() {
        document.removeEventListener('click', this.handleGlobalClick);
    }
}
